var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app"},[_c('keep-alive',{attrs:{"include":_vm.include,"max":10}},[(_vm.isRouterAlive)?_c('router-view',{ref:"router",staticClass:"router"}):_vm._e()],1)],1),(_vm.home === true)?_c('Home'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }